import { format, parseISO } from "date-fns";

import { DataTable, ExtendedColumnDef } from "@/components/Datatable";
import { IStoreInvoice } from "src/@types/store-invoice";

import {
  DISPLAY_DATE_FORMAT,
  EMPTY_CELL,
  EXCHANGE_NO,
  EXCHANGE_YES,
} from "../types";

interface StoreInvoiceTableProps {
  readonly invoices: IStoreInvoice[];
  readonly isLoading: boolean;
  readonly emptyMessage: string;
}

const text = (value: string | number | null): string =>
  value === null || value === "" ? EMPTY_CELL : String(value);

const columns: ExtendedColumnDef<IStoreInvoice>[] = [
  {
    accessorKey: "operationDate",
    header: "Data",
    cell: ({ row }) =>
      format(parseISO(row.original.operationDate), DISPLAY_DATE_FORMAT),
  },
  {
    accessorKey: "operationTime",
    header: "Hora",
    cell: ({ row }) => text(row.original.operationTime),
  },
  { accessorKey: "storeCode", header: "Loja" },
  { accessorKey: "cashRegister", header: "Caixa" },
  { accessorKey: "controlCode", header: "Controle" },
  {
    accessorKey: "invoiceNumber",
    header: "Nº da Nota",
    cell: ({ row }) => text(row.original.invoiceNumber),
  },
  {
    accessorKey: "nfeNumber",
    header: "Nº NF-e",
    cell: ({ row }) => text(row.original.nfeNumber),
  },
  {
    accessorKey: "series",
    header: "Série",
    cell: ({ row }) => text(row.original.series),
  },
  { accessorKey: "documentTypeLabel", header: "Tipo de Nota" },
  { accessorKey: "invoiceStatusLabel", header: "Sit. Nota" },
  { accessorKey: "saleStatusLabel", header: "Sit. Venda" },
  {
    accessorKey: "receipt",
    header: "Recibo",
    cell: ({ row }) => text(row.original.receipt),
  },
  {
    accessorKey: "protocol",
    header: "Protocolo",
    cell: ({ row }) => text(row.original.protocol),
  },
  {
    accessorKey: "cancellationProtocol",
    header: "Prot. Cancelamento",
    cell: ({ row }) => text(row.original.cancellationProtocol),
  },
  {
    accessorKey: "accessKey",
    header: "Chave de Acesso",
    cell: ({ row }) => (
      <span className="font-mono text-xs whitespace-nowrap">
        {text(row.original.accessKey)}
      </span>
    ),
  },
  {
    accessorKey: "usedInExchange",
    header: "Usada em Troca",
    cell: ({ row }) =>
      row.original.usedInExchange ? EXCHANGE_YES : EXCHANGE_NO,
  },
];

export function StoreInvoiceTable({
  invoices,
  isLoading,
  emptyMessage,
}: StoreInvoiceTableProps) {
  return (
    <div className="mt-4 overflow-x-auto">
      <DataTable
        columns={columns}
        data={invoices}
        isLoading={isLoading}
        emptyMessage={emptyMessage}
      />
    </div>
  );
}
